module.exports = __webpack_public_path__ + "img/no-data-injury.d7268aef.svg";